import React, {useCallback} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Dadata from '@services/dadata';
import debounce from 'lodash/debounce';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { useTranslation } from 'react-i18next';

const AutocompleteDadata = ({name, scheme, defaultValue, refs}) => {
    const [controlledValue, setControlledValue] = React.useState(defaultValue ? defaultValue : '');
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const [inputValue, setInputValue] = React.useState(defaultValue ? defaultValue : '');
    const [options, setOptions] = React.useState([]);
    const handleChange = (newInputValue) => {
        delayedQuery(newInputValue);
    };
    const dadataQuery = async (value) => {
        const dadata = new Dadata();
        const result = await dadata.get(value);
        if (!result.error) {
            let optionsSuggestions = [];
            result.suggestions.map(suggestion => {
                optionsSuggestions.push(suggestion);
            });
            setOptions(optionsSuggestions);
        }
    };
    const delayedQuery = useCallback(debounce(val => dadataQuery(val), 200), []);

    const helperText = currentLang === 'en' &&  scheme.helper_text_en ? scheme.helper_text_en : scheme.helper_text
    const label = currentLang === 'en' && scheme.label_en ? scheme.label_en : scheme.label

    return (
        <React.Fragment>
            <input
                type="hidden"
                ref={input => refs[name] = input}
                value={inputValue ? inputValue : ''} />
            <Autocomplete
                value={controlledValue}
                onChange={(e, newValue) => {
                    setControlledValue(newValue);
                }}
                inputValue={inputValue}
                onInputChange={(e, newInputValue) => {
                    setInputValue(newInputValue);
                    handleChange(newInputValue);
                }}
                size="small"
                fullWidth
                getOptionLabel={(option) => (typeof option === 'string' ? option : option.value)}
                freeSolo
                autoComplete
                includeInputInList
                filterSelectedOptions
                filterOptions={(x) => x}
                noOptionsText="Нет результатов"
                options={options}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        variant="outlined"
                        helperText={helperText}
                        required={scheme.required === true}
                    />
                )}
                renderOption={(option, { inputValue }) => {
                    const matches = match(option.value, inputValue);
                    const parts = parse(option.value, matches);
                    return (
                        <div>
                            {parts.map((part, index) => {
                                return (
                                    <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                    {part.text}
                                </span>
                                )
                            })}
                        </div>
                    );
                }}
            />
        </React.Fragment>
    );
};

export default AutocompleteDadata;